export function formataDataHora(texto, retorno) {
    
    let dataFinal = new Date(texto)
    let diaFinal = dataFinal.getDate()
    let mesFinal = dataFinal.getMonth() + 1
    let anoFinal = dataFinal.getFullYear()
    let horas = dataFinal.getHours()
    let minutos = dataFinal.getMinutes()
    
    if(horas.toString().length === 1){horas = "0" + horas.toString()}
    if(minutos.toString().length === 1){minutos = "0" + minutos.toString()}

    let horasMinutos = horas + ':' + minutos;
    
    if (diaFinal < 10) {
        diaFinal = "0" + diaFinal
    }
    if (mesFinal < 10) {
        mesFinal = "0" + mesFinal
    }
    if(retorno === "data-hora"){
        return diaFinal + "/" + mesFinal + "/" + anoFinal + " às " + horasMinutos;
    }else if(retorno === "data"){
        return diaFinal + "/" + mesFinal + "/" + anoFinal
    }else if(retorno === "atad"){
        return anoFinal + "-" + mesFinal + "-" + diaFinal    
    }else if(retorno === "hora"){
        return horasMinutos;
    }    
}